function y(c) {
  return new Promise((i, m) => {
    const o = document.createElement("iframe");
    o.src = c, o.style.display = "none", o.onload = () => i(o), document.body.appendChild(o);
  });
}
function C() {
  return (Math.random() + 1).toString(36).substring(7);
}
var g;
((c) => {
  function i(m = {}) {
    const o = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), l = {
      checkProtocol: !0,
      ...m
    };
    function p(e) {
      if (typeof e.data != "object")
        try {
          const n = JSON.parse(e.data);
          if (l.checkProtocol && n.protocol !== "ch-fc")
            return;
          const t = n, a = o.get(t.id);
          if (a === void 0) {
            const d = s.get(t.event);
            if (d === void 0)
              return;
            const M = (r) => {
              var f;
              (f = e.source) == null || f.postMessage(
                JSON.stringify({
                  id: t.id,
                  event: t.event,
                  data: r,
                  protocol: "ch-fc"
                }),
                {
                  targetOrigin: "*"
                }
              );
            };
            for (let r = 0; r < d.length; r += 1)
              d[r](t.data, M);
            return;
          }
          a(n.data), o.delete(n.id);
        } catch (n) {
          console.error("Cannot parse message", n);
        }
    }
    window.addEventListener("message", p);
    function u(e, n) {
      return new Promise((t) => {
        const a = {
          id: C(),
          ...n,
          protocol: "ch-fc"
        };
        o.set(a.id, t), e == null || e.postMessage(JSON.stringify(a), "*");
      });
    }
    return {
      /**
       * Loads the frame communication server via iframe,
       * contains all the client functions
       */
      client: async (e) => {
        const n = await y(e);
        return {
          /**
           * send messages scoped to the current iframe
           */
          sendMessage: (t) => u(n.contentWindow, t)
        };
      },
      /**
       * Namespace for all the server functions such as listening for messages
       * and responding to them
       */
      host: () => ({
        /**
         * Listens for incoming events
         */
        on: (e, n) => {
          const t = s.get(e);
          if (t === void 0) {
            s.set(e, [n]);
            return;
          }
          t.push(n);
        },
        /**
         * Removes outgoing events
         * @param event
         */
        off: (e) => {
          s.delete(e);
        },
        /**
         * Sends a message to the parent (client)
         */
        sendMessage: (e) => u(window.parent, e)
      })
    };
  }
  c.createFrameCommunication = i;
})(g || (g = {}));
export {
  g as FrameCommunicationAPI
};
//# sourceMappingURL=index.js.map
